import React from 'react'
import './NotFoundPage.css'

function NotFoundPage() {
    return (
        <section className='Not-found'>
            <h2>404-Page not found</h2>
            <p>You may want to start over</p>
        </section>
    )
}

export default NotFoundPage